'use strict';
window.jQuery = window.$ = require('jquery');
const slick = require('slick-carousel');
const popup = require("jquery-popup-overlay");

import Answer from "./assessment/Answer";
import Question from "./assessment/Question";
import QuestionList from "./assessment/QuestionList";
import "./assessment/jquery.assessment-1.0.0.js";

$(document).ready(function() {

    $('.assessment-tabs .assessment-tabs-header ul > li').click(function() {
        // If the tab clicked is already active, skip.
        if ($(this).hasClass('active')) {
            return false;
        }

        const tabId = $(this).data('tab-id');

        // Set the active tab header.
        $(`.assessment-tabs .assessment-tabs-header ul > li:not([data-tab-id="${tabId}"])`).removeClass('active');
        $(this).addClass('active');

        // Set the active tab body.
        $(`.assessment-tabs .assessment-tabs-body > div:not([data-tab-id="${tabId}"])`).removeClass('active');
        $(`.assessment-tabs .assessment-tabs-body > div[data-tab-id="${tabId}"]`).addClass('active');

        return false;
    });

    const $assessmentSlider = $('.assessment-form-slider');
    const $assessmentSliderPrev = $('.assessment-app-page-footer .vbtk-slick-arrow-prev');
    const $assessmentSliderNext = $('.assessment-app-page-footer .vbtk-slick-arrow-next');
    const $assessmentSliderSubmit = $('.assessment-app-page-footer .vbtk-slick-arrow-submit');
    const $assessmentSlides = $assessmentSlider.find('.assessment-form-slide');
    const $assessmentProgressBar = $('.header-progress-bar .assessment-progress-bar');
    const $assessmentProgressBarBlocks = $assessmentProgressBar.find('.progress-block');
    const $assessmentSingleAnswers = $('.assessment-app-page-form .answer :input[type="radio"]');
    const $assessmentMultiAnswers = $('.assessment-app-page-form .answer :input[type="checkbox"]');
    const $assessmentSidebarOne = $('.assessment-app-sidebar.section-one');
    const $assessmentSidebarTwo = $('.assessment-app-sidebar.section-two');
    const $assessmentSidebarThree = $('.assessment-app-sidebar.section-three');

    const $assessment = $assessmentSlider.assessment({
        questionEl: '.assessment-form-slide',
        questionTextEl: 'h3'
    });

    // https://kenwheeler.github.io/slick/

    $assessmentSlider.slick({
        vertical: false, // enables the vertical sliding
        slidesToShow: 1, // show one slide at a time
        slidesToScroll: 1, // scroll one slide at a time
        swipeToSlide: false, // important to prevent the user from swiping on mobile without answering
        draggable: false, // important to prevent the user from dragging with a mouse answering
        infinite: false, // we don't want them cycling back around to question 1
        adaptiveHeight: true, // let's test the best setting here. true/false
        dots: true, // this enables our pagination
        appendDots: $('.header-pagination'), // this allows us to attach our pagination to any element on the page
        customPaging: function(slick,index) { // where we build our custom pagination. We hide non-active pagination "dots"
            return index + ' of ' + slick.slideCount + ' questions answered';
        },
        arrows: true, // this enables our slider buttons
        appendArrows: $('.assessment-app-page-footer'), // this allows us to attach our pagination to any element on the page
        prevArrow: $assessmentSliderPrev,
        nextArrow: $assessmentSliderNext
    });

    $assessmentSingleAnswers.on('change', function(e) {
        const $label = $(this).closest('label');
        const $form = $(this).closest('.assessment-app-page-form');
        const $allLabels = $form.find('label');
        $allLabels.removeClass('active');
        $label.addClass('active');
    });

    $assessmentMultiAnswers.on('change', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const checked = $(this).is(':checked');
        const $label = $(this).closest('label');
        const $form = $(this).closest('.assessment-app-page-form');
        const id = $(this).closest('.answer').data('id');
        const singleChoice = $form.data('single-choice');
        const $slide = $form.closest('.assessment-form-slide');

        if (id === singleChoice) {
            const $otherInputs = $form.find(`.answer:not([data-id="${singleChoice}"]) :input`);
            const $otherLabels = $otherInputs.closest('label');

            if (checked) {
                $otherLabels.toggleClass('active', false);
                $otherInputs.prop('checked', false);
                $assessment.assessment('setResults', $(this).val(), $slide.data('id'));
            }

            $label.toggleClass('active', checked);
        } else {
            const $singleChoiceInput = $form.find(`.answer[data-id="${singleChoice}"] :input`);
            const $singleChoiceLabel = $singleChoiceInput.closest('label');
            if (checked) {
                $singleChoiceInput.prop('checked', false);
                $singleChoiceLabel.toggleClass('active', false);
                const $checked = $form.find(`:input:checked`);
                const checkedIds = $checked.map(function(_, c) {
                    return $(c).val();
                }).toArray();
                $assessment.assessment('setResults', checkedIds, $slide.data('id'));
            }
            $label.toggleClass('active', checked);
        }
    });

    $assessmentSlider.on('setResults', function(e, question, results) {
        if (results.length > 0) {
            $assessmentSliderNext.addClass('active');
            $assessmentSliderSubmit.addClass('active');
        } else {
            $assessmentSliderNext.removeClass('active');
            $assessmentSliderSubmit.removeClass('active');
        }
    });



    $assessmentSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        // Set the current progress.
        $assessmentProgressBarBlocks.each(function(progressBarBlockIndex, progressBarBlock) {
            $(progressBarBlock).toggleClass('active', progressBarBlockIndex < nextSlide);
        });

        // Navigate the assessment.
        if (currentSlide < nextSlide) {
            $assessment.assessment('next');
        } else {
            $assessment.assessment('previous');
        }

        const currentQuestion = $assessment.assessment('getCurrentQuestion');

        // If the question after assessment navigation is unanswered, disable the next button.
        if (currentQuestion.getResults().length === 0) {
            $assessmentSliderNext.removeClass('active');
            $assessmentSliderSubmit.removeClass('active');
        } else {
            $assessmentSliderNext.addClass('active');
            $assessmentSliderSubmit.addClass('active');
        }

        if (currentQuestion.getNext() === null) {
            $assessmentSliderNext.css('display', 'none');
            $assessmentSliderSubmit.css('display', 'inline-block');
        } else {
            $assessmentSliderSubmit.css('display', 'none');
            $assessmentSliderNext.css('display', 'inline-block');
        }

        if (nextSlide < 3) {
            $assessmentSidebarOne.show();
            $assessmentSidebarTwo.hide();
            $assessmentSidebarThree.hide();
        } else if (nextSlide >= 3 && nextSlide < 7) {
            $assessmentSidebarOne.hide();
            $assessmentSidebarTwo.show();
            $assessmentSidebarThree.hide();
        } else {
            $assessmentSidebarOne.hide();
            $assessmentSidebarTwo.hide();
            $assessmentSidebarThree.show();
        }

        // Determine available answer options for this slide.
        if (nextSlide === 5 || nextSlide === 6) {
            const questionList = $assessment.assessment('getQuestionList');
            const topicQuestion = questionList.getNodeByQuestionId(5);
            const topicQuestionResults = topicQuestion.getResults();
            const $currentSlide = $(`.assessment-form-slide[data-id="${nextSlide + 1}"]`);
            const $currentSlideAnswers = $currentSlide.find('.answer:not([data-id="7"]):not([data-id="1"])');
            $currentSlideAnswers.css('display', 'none');

            for (const topicQuestionResult of topicQuestionResults) {
                if (topicQuestionResult.id === '1') {
                    $currentSlideAnswers.css('display', 'block');
                } else {
                    $currentSlideAnswers.filter(function(_, currentSlideAnswer) {
                        return $(currentSlideAnswer).data('id').toString() === topicQuestionResult.id;
                    }).css('display', 'block');
                }
            }
        }

    });

    $('.assessment-popup').popup({
        pagecontainer: '#assessment-app',
        closebutton: true
    });

});